
import flatpickr from 'flatpickr'
import WMSCapabilities from 'ol/format/WMSCapabilities'
import Plotly from 'plotly.js-dist'
import { FlatpickerInstance } from '../index'
// import { ajaxSettings } from 'jquery'

export function plotTimeseries (evt, layer, overlay, view, geoserverPrefix, title, xAxis, yAxis, xmin, ymin) {
    var layerWms = layer.source
    var viewResolution = /** @type {number} */ (view.getResolution())
    // var capabilitiesLink = "http://rsswebserver.rssgmbh.intern:8080/geoserver/globedrought/dsi_2003-2016/wms?SERVICE=WMS&VERSION=2.0.0&REQUEST=GetCapabilities"
    var capabilitiesLink = geoserverPrefix + '/geoserver/' + layer.params_.LAYERS.replace(':', '/') + '/wms?SERVICE=WMS&VERSION=2.0.0&REQUEST=GetCapabilities'
    console.log(capabilitiesLink)
    var parser = new WMSCapabilities()
    fetch(capabilitiesLink).then(function (response) { return response.text() }).then(function (text) {
        var result = parser.read(text)
        var times = result.Capability.Layer.Layer[0].Dimension[0].values.split(',')
        times = times.filter((x, i) => i % 10 === 0)

        // var times =["2005-02","2006-03","2007-03"]
        // console.log('start map')
        var values = []
        var timesList = []
        for (var time of times) {
            // console.log(values)
            console.log(time)

            var url = layer.getFeatureInfoUrl(
                evt.coordinate, viewResolution, 'EPSG:3857',
                { INFO_FORMAT: 'application/json', TIME: time })
            // console.log("TimeSeries:")
            // console.log(url)
            if (url) {
                values.push(fetch(url)
                    .then((response) => {
                        if (response.ok) {
                            var respTxt = response.json()
                        }
                        // IS there no way to get the value of promis here?

                        var pixelValue = respTxt
                        console.log(pixelValue)
                        return pixelValue
                    }))
                // values.push(getPixelValueFromUrl(url, values, times_list, time))
            }
        }
        console.log('selectedDates')
        console.log(FlatpickerInstance.selectedDates)
        console.log(FlatpickerInstance.selectedDates[0])

        var layout = {
            title: title,
            x: 'date',
            y: 'value',
            margin: { l: 50, r: 50, b: 50, t: 70 },
            shapes: [
                {
                    type: 'line',
                    yref: 'paper',
                    y0: 0,
                    y1: 1,
                    xref: 'x',
                    line: { dash: 'dashdot', color: 'grey' },
                    x0: FlatpickerInstance.selectedDates[0],
                    x1: FlatpickerInstance.selectedDates[0]
                    //   x0: times[10],
                    //    x1: times[10],
                }
            ],
            yaxis: {
                showgrid: true,
                gridwidth: 1,
                gridcolor: 'grey'
            },
            xaxis: {
                showgrid: true,
                gridwidth: 1,
                gridcolor: 'grey'
            },
            width: 500
        }
        console.log(title)
        var content = {
            x: times,
            y: new Array(values.length).fill(0),
            type: 'scatter',
            line: { color: '#D69F1B' }
        }
        overlay.setPosition(evt.coordinate)
        Plotly.newPlot('popup-content', [content], layout)
        Promise.allSettled(values).then(function (values) {
            console.log(values)
            var finalValues = []
            values.forEach(function (item) {
                // final_values.push(item["features"][0]["properties"]["GRAY_INDEX"]);
                try {
                    finalValues.push(item.value.features[0].properties.GRAY_INDEX)
                } catch (err) {
                    finalValues.push(NaN)
                }
            })

            overlay.setPosition(evt.coordinate)
            var nonnanFinalValues = finalValues.filter(value => !Number.isNaN(value))
            Plotly.animate('popup-content', {
                data: [{ y: finalValues, x: times, line: { color: '#D69F1B' } }],
                layout: {
                    title: title,
                    x: 'date',
                    y: 'value',
                    yaxis: { range: [Math.min(...nonnanFinalValues), Math.max(...nonnanFinalValues)] },
                    showlegend: false
                }
            }, {
                transition: {
                    duration: 500,
                    easing: 'cubic-in-out'
                },
                frame: {
                    duration: 500
                }
            })
            // Plotly.plot('popup-content', [content], layout)
        })
    })
}
export function plotPiechart (evt, values, labels, overlay, title) {
    var content = [{
        values: values,
        labels: labels,
        type: 'pie'
    }]

    var layout = {
        title: title,
        height: 400,
        width: 500,
        showlegend: true
    }

    content.innerHTML = ''
    overlay.setPosition(evt.coordinate)
    // Plotly.newPlot('myDiv', data, layout);
    Plotly.newPlot('popup-content', content, layout)
}
export function plotTimeseriesVector (evt, overlay, features, title) {
    console.log("timeseriesVectorPlot!")
    overlay.setPosition(evt.coordinate)
    // content.innerHTML = features[0].get('CRHAZ_' + flatpickr_instance.currentYear) + '<br>'
    var props = features[0].properties_
    console.log(props)
    // ['ADMIN', 'R_HARVAREA', 'GRIDCELLS', 'CODE_ISO', 'CRHAZ_8016'].forEach(element => delete props[element])
    // ['COL', 'VULNERAB', 'GRIDCELLS', 'CODE_ISO', 'CRHAZ_8016'].forEach(element => delete props[element])
    // console.log(props)
    Object.keys(props).forEach(function (item) {
        if (!item.includes('RHAZ')) {
            delete props[item]
        }
        if (item.includes('LEG_RHAZ')) {
            delete props[item]
        }
        if (item.includes('8016')) {
            delete props[item]
        }
        if (item.includes('layer')) {
            delete props[item]
        }
    })
    console.log(props)

    var xLabels = Object.keys(props).map(function (x) {
        x = x.replace('CRHAZ_', '')
        x = x.replace('RHAZ_', '')

        return x
    })
    // xLabels = Object.keys(xLabels).map(function (x) { return x.replace('RHAZ_', '') })
    console.log(xLabels)
    // content.innerHTML = JSON.stringify(features[0].properties_) + '<br>'
    var trace1 = {
        x: xLabels,
        y: Object.values(props),
        type: 'scatter',
        line: { color: '#D69F1B' }
    }
    var layout = {
        title: title,
        yaxis: {
            showgrid: true,
            gridwidth: 1,
            gridcolor: 'grey'
        },
        xaxis: {
            showgrid: true,
            gridwidth: 1,
            gridcolor: 'grey'
        },
        width: 500,
        margin: { l: 50, r: 50, b: 50, t: 70 },
        shapes: [
            {
                type: 'line',
                yref: 'paper',
                y0: 0,
                y1: 1,
                xref: 'x',
                line: { dash: 'dashdot', color: 'grey' },
                x0: FlatpickerInstance.currentYear,
                x1: FlatpickerInstance.currentYear
                //   x0: times[10],
                //    x1: times[10],
            }
        ]
    }
    overlay.setPosition(evt.coordinate)
    Plotly.newPlot('popup-content', [trace1], layout)
}
